import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UserAccountModel, SubscriptionCadence } from 'starbase-launcher';
import { AppGlobalsService } from '../app-globals.service';
import { LU_SubscriptionPriceModel_ext } from '../models/lu_subscriptionprice';

@Component({
  selector: 'app-plan-choices',
  templateUrl: './plan-choices.component.html',
  styleUrls: ['./plan-choices.component.css']
})
export class PlanChoicesComponent implements OnInit {
  @Input() subUserAcct: UserAccountModel;
  @Input() signupMode = false;
  @Input() topText = 'Subscribe now to see detailed image data and unlock many other features!';
  @Input() isHandset = false;
  @Input() devOrTestingMode = false;

  @Output() subscriptionCancelEvent = new EventEmitter<any>();
  @Output() openPaymentFormEvent = new EventEmitter<LU_SubscriptionPriceModel_ext>();

  public allSubscriptionPlans: LU_SubscriptionPriceModel_ext[] = [];
  public freePlan: LU_SubscriptionPriceModel_ext;

  constructor(private appGlobalsSvc: AppGlobalsService) {
    this.freePlan = PlanChoicesComponent.FreePlan();
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  public static FreePlan(): LU_SubscriptionPriceModel_ext {
    const theFreePlan = new LU_SubscriptionPriceModel_ext(-1);
    theFreePlan.description = 'Free use of partial site functionality. See what we have before subscribing.';
    theFreePlan.name = 'Free';
    theFreePlan.price = 0.00;
    theFreePlan.taxable = false;
    theFreePlan.cadence = SubscriptionCadence.MONTHLY;
    theFreePlan.cadenceDisp = {
      selected: true,
      key: 'DAILY',
      value: theFreePlan.cadence
    };
    theFreePlan.accompanyingFilePath = 'assets/PRICINGTABLE_FREE.png';
    theFreePlan.altFilePath = 'assets/FREE_selected.png';
    return theFreePlan;
  }

  ngOnInit(): void {
    this.allSubscriptionPlans = this.appGlobalsSvc.allSubscriptionPlans;
  }

}
